import FilterUtils from '@/shared/utils/filters';

export default class RuleGroupRangeParameter {
  quantidade: any;

  valor: string;

  constructor(obj: any = {}, precision: number = 2) {
    this.quantidade = obj.quantidade;
    this.valor = obj.valor;
  }
}
